export default __webpack_public_path__ + "static/media/477.4dc17d44.gif";